import { config } from '@config';
import { notification } from 'antd';
import { type AxiosError, axios } from 'foca-axios';

const http = axios.create({
  baseURL: config.api_url,
  timeout: 10_000,
  cache: {
    enable: false,
  },
});

http.interceptors.request.use((cfg) => {
  if (cfg.baseURL === config.api_url) {
    cfg.headers ||= {};
    cfg.headers['api-version'] ||= 'v2';
  }
  return cfg;
});

http.interceptors.response.use(undefined, (err: AxiosError) => {
  if (axios.isCancel(err)) return;

  notification.open({
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    message: (err.response?.data || err.message) as React.ReactNode,
  });

  throw err;
});

export default http;
